import { AxiosResponse } from 'axios';
import { call } from 'redux-saga/effects';
import { takeEveryAsync } from 'saga-toolkit';
import { RequestOptions } from '../../../../types/RequestOptions';
import request from '../../../../utils/request';
import { fetchEvent, fetchEventPayload } from './index';

export function* eventSaga() {
  yield takeEveryAsync(fetchEvent.type, fetchEventSaga);
}

function* fetchEventSaga(action: fetchEventPayload) {
  const requestOptions: RequestOptions = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  const response: AxiosResponse = yield call(
    request,
    `/event/${action.meta.arg}?include=type,timeInterval,description,dateTimeFormat,location,coordinates,cover,gallery,currency,minmaxticketsprices,seller_public_information,sellerFeatures,fees_and_taxes,numberOfPrivateTicketTypes`,
    requestOptions,
  );

  return response.data;
}
